import { render, staticRenderFns } from "./HelpCenterBubble.vue?vue&type=template&id=cfab6c4e&scoped=true"
import script from "./HelpCenterBubble.vue?vue&type=script&lang=js"
export * from "./HelpCenterBubble.vue?vue&type=script&lang=js"
import style0 from "./HelpCenterBubble.vue?vue&type=style&index=0&id=cfab6c4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfab6c4e",
  null
  
)

export default component.exports